import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, SparklesIcon, DropletIcon } from 'lucide-react';
const services = [{
  icon: ScissorsIcon,
  title: 'Precision Cuts',
  description: 'From urban fades to geometric bobs. Every cut is a personalized work of art.'
}, {
  icon: SparklesIcon,
  title: 'Beard Architecture',
  description: 'Signature beard design and sculpting. Your beard deserves an architect.'
}, {
  icon: DropletIcon,
  title: 'Hair Treatments',
  description: 'Hydration and care for all hair types. Deep nourishment for a natural shine.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ServicesSection() {
  return <section className="py-24 px-4 bg-dark" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="font-display text-3xl md:text-5xl text-gold mb-4" data-id="element-104">
            Our Services
          </h2>
          <div className="h-[1px] w-24 bg-gold/30 mx-auto" data-id="element-105"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-106">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={cardVariants} whileHover={{
            y: -10
          }} className="bg-[#222222] rounded-lg p-8 border-t-4 border-gold shadow-lg hover:shadow-[0_10px_30px_rgba(201,168,76,0.15)] transition-all duration-300 flex flex-col items-center text-center group" data-id="element-107">
                <div className="w-16 h-16 rounded-full bg-dark flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-108">
                  <Icon className="w-8 h-8 text-gold" data-id="element-109" />
                </div>
                <h3 className="font-display text-2xl text-gold mb-4 italic" data-id="element-110">
                  {service.title}
                </h3>
                <p className="font-body text-cream/80 font-light leading-relaxed" data-id="element-111">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}